import { Box } from "@mui/material";

export function BACKGROUND_CUT(bgcolor, cutSize) {
    if (!cutSize) {
        cutSize = 10;
    }
    return "linear-gradient(-135deg, transparent " + cutSize + "px, " + bgcolor + " 0)"
}

export function BoxCut(props) {
    const bgcolor = props.sx && props.sx.backgroundColor || 'transparent';
    const { cutSize, border, ...rest } = props;

    if (border) {
        return <BoxCut sx={{ backgroundColor: border, padding: '1px' }}>
            <BoxCut sx={props.sx} cutSize={cutSize || 10}>
                {props.children}
            </BoxCut>
        </BoxCut>
    }

    return <Box
        {...rest}
        sx={{ ...props.sx, background: BACKGROUND_CUT(bgcolor, cutSize || 10) }}>
        {props.children}
    </Box>
}